import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiTournamentsService } from '../../../../services/tournaments/api/api-tournaments.service';
import { AlertsService } from '../../../../services/alerts.service';
import { TournamentReward } from '../../../../models/tournaments/tournament-reward.model';
import { TournamentType } from '../../../../enums/tournaments/tournament-type.enum';

@Component({
  selector: 'app-tournament-add-modal',
  templateUrl: './tournament-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class TournamentAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  type: number = 0;
  startDate: string = '';
  endDate: string = '';
  costQuantity: number = 0;
  rewardTotalQuantity: number = 0;
  usersCount: number = 0;
  rewards: TournamentReward[] = [];

  readonly tournamentTypes = Object.entries(TournamentType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiTournamentsService: ApiTournamentsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.type = 0;
    this.startDate = '';
    this.endDate = '';
    this.costQuantity = 0;
    this.rewardTotalQuantity = 0;
    this.usersCount = 0;
    this.rewards = [];
    this.isLoading = false;
    this.modal.show();
  }

  addReward(): void { this.rewards.push(new TournamentReward()); }
  removeReward(i: number): void { this.rewards.splice(i, 1); }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    this.apiTournamentsService.addTournament(this.type, startTimestamp, endTimestamp, this.costQuantity, this.rewardTotalQuantity, this.rewards).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Tournament added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding tournament : ' + error);
      }
    );
  }
}
